"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mathjs = __importStar(require("mathjs"));

var expr = __importStar(require("./expressions"));

function nodeToExpression(node, variables) {
  var nodeUnsafe = node;

  if (node.isOperatorNode && node.args) {
    var exprA = nodeToExpression(node.args[0], variables);

    if (nodeUnsafe.isBinary()) {
      var exprB = nodeToExpression(node.args[1], variables);

      switch (node.op) {
        case "+":
          return new expr.Add(exprA, exprB);

        case "-":
          return new expr.Subtract(exprA, exprB);

        case "*":
          return new expr.Multiply(exprA, exprB);

        case "/":
          return new expr.Divide(exprA, exprB);

        case "^":
          return new expr.Power(exprA, exprB);

        default:
          throw new Error("Unknown binary operator " + node.op);
      }
    } else {
      switch (node.op) {
        case "-":
          return new expr.Negate(exprA);

        default:
          throw new Error("Unknown unary operator " + node.op);
      }
    }
  } else if (node.isSymbolNode && node.name) {
    if (!(node.name in variables)) {
      variables[node.name] = new expr.Variable(node.name);
    }

    return variables[node.name];
  } else if (node.isConstantNode && node.value) {
    return new expr.Constant(node.value);
  } else if (node.isFunctionNode && node.args) {
    var fn = nodeUnsafe.fn; // Bug in type def. fn is symbol, not string

    var _exprA = nodeToExpression(node.args[0], variables);

    switch (fn.name) {
      case "sin":
        return new expr.Sin(_exprA);

      case "cos":
        return new expr.Cos(_exprA);

      case "tan":
        return new expr.Tan(_exprA);

      case "log":
        return new expr.Log(_exprA);

      case "sqrt":
        return new expr.Power(_exprA, new expr.Constant(0.5));

      case "exp":
        return new expr.Exp(_exprA);

      case "abs":
        return new expr.Abs(_exprA);

      case "sign":
        return new expr.Sign(_exprA);

      case "D":
        {
          var _exprB = nodeToExpression(node.args[1], variables);

          return new expr.Derivative(_exprA, _exprB);
        }

      default:
        throw new Error("Unknown function " + fn.name);
    }
  } else if (node.isParenthesisNode && nodeUnsafe.content) {
    return nodeToExpression(nodeUnsafe.content, variables);
  }

  throw new Error("Unknown node: " + node.toString() + " " + node.type);
}

function parseExpression(expressionString) {
  var rootNode = mathjs.simplify(mathjs.parse(expressionString));
  return nodeToExpression(rootNode, {});
}

exports.parseExpression = parseExpression;

function expressionToNode(expression) {
  var parsed = mathjs.parse(expression.evaluateToString());
  var simplified = mathjs.simplify(parsed);
  return simplified;
}

exports.expressionToNode = expressionToNode;